import React, { createContext, useReducer } from 'react'
import { companyReducer, superAdminReducer, subscriptionReducer, permissionReducer } from '../reducer/superAdminReducer'

export const SuperAdminContext = createContext({})

export const SuperAdminContextProvider = ({ children }) => {
  const [company, companyDataDispatch] = useReducer(companyReducer, { companies: false, loading: false })
  const [subscriptions, subscriptionDataDispatch] = useReducer(subscriptionReducer, { subscriptions: false, loading: false })
  const [superAdmin, superAdminDataDispatch] = useReducer(superAdminReducer, { superAdmins: false, loading: false })
  // const [permissions, permissionDispatch] = useReducer(permissionReducer, { permissions: false, loading: false })
  function getAllCompanies(data) {
    companyDataDispatch({
      type: 'GET_ALL_COMPANIES',
      payload: data,
    })
  }

  function getNewSubscriptions(data) {
    subscriptionDataDispatch({
      type: 'GET_ALL_SUBSCRIPTIONS',
      payload: data,
    })
  }

  // function getActiveSubscriptions(data) {
  //   subscriptionDataDispatch({
  //     type: 'ACTIVE_SUBSCRIPTIONS',
  //     payload: data,
  //   })
  // }

  function getSingleSubscription(data) {
    subscriptionDataDispatch({
      type: 'GET_ALL_COMPANIES',
      payload: data,
    })
  }

  function addSubscription(data) {
    companyDataDispatch({
      type: 'GET_ALL_COMPANIES',
      payload: data,
    })
  }

  function getNewPermissions(data) {
    companyDataDispatch({
      type: 'GET_ALL_COMPANIES',
      payload: data,
    })
  }

  function getAllSuperAdmins(data) {
    superAdminDataDispatch({
      type: 'GET_ALL_SUPERADMINS',
      payload: data,
    })
  }

  return (
    <SuperAdminContext.Provider
      value={{
        getNewCompanies: getAllCompanies,
        companies: company.companies,
        subscriptions: subscriptions,
        getNewSuperAdmins: getAllSuperAdmins,
        getSingleSubscription: getSingleSubscription,
        addSubscription:addSubscription,
        getNewSubscriptions: getNewSubscriptions,
        superAdmins: superAdmin.superAdmins,
        getNewPermissions: getNewPermissions,
        // activeSubscriptions: activeSubscriptions,
        // setActiveSubscriptions: activeSubscriptionDispatch,
        // getActiveSubscriptions: getActiveSubscriptions,
      }}
    >
      {children}
    </SuperAdminContext.Provider>
  )
}
